import { render, staticRenderFns } from "./FormMarkdown.vue?vue&type=template&id=4edf8911&"
import script from "./FormMarkdown.vue?vue&type=script&lang=js&"
export * from "./FormMarkdown.vue?vue&type=script&lang=js&"
import style0 from "./FormMarkdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports